function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 6.444C4 5.1 5.1 4 6.444 4h9.776v2.444H6.444v17.112h9.776V26H6.444A2.451 2.451 0 014 23.556V6.444zm17.322 7.334l-3.098-3.1L19.95 8.95 26 15l-6.049 6.05-1.727-1.728 3.098-3.1h-8.047v-2.444h8.047z"
});
function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
}
export default SvgLogout;